<template>
  <card-info title="Basic Information">
    <template v-slot:above-title>
      <h3 v-if="learningUnit" class="mb-4 font-weight-bold">
        {{ learningUnit.name }}
      </h3>
    </template>

    <template v-slot:below-title>
      <div v-if="user" class="mt-4 mb-3">
        <BaseUserProfile :user-name="userFullName">
          <template slot="name">
            <div class="ml-2">
              <div ref="user--fullname" class="font-weight-bold">
                {{ userFullName }}
              </div>
              <div ref="user--email" class="text-dark mb-2 small">
                {{ user.email }}
              </div>
            </div>
          </template>
        </BaseUserProfile>
      </div>

      <div v-if="learningUnit" class="info-learning-unit">
        <b-row class="my-1">
          <b-col cols="5" class="font-weight-bold">Type:</b-col>
          <b-col ref="learning-unit-type">{{ type || '-' }} </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col cols="5" class="font-weight-bold">Number of Online Meetings:</b-col>
          <b-col ref="learning-unit-number-of-online-meetings"
            >{{ numberOfOnlineMeetings || '-' }}
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col cols="5" class="font-weight-bold">Visibility:</b-col>
          <b-col ref="learning-unit-visibility">{{ visibility || '-' }}</b-col>
        </b-row>
        <b-row class="my-1">
          <b-col cols="5" class="font-weight-bold">Status:</b-col>
          <b-col ref="learning-unit-status">{{ publicationStatus || '-' }}</b-col>
        </b-row>
        <b-row class="my-1">
          <b-col cols="5" class="font-weight-bold">Submitted Date:</b-col>
          <b-col ref="learning-unit-submitted-date">{{
            submittedDate ? formatedDatetime(submittedDate, 'D MMMM YYYY hh:mm') : '-'
          }}</b-col>
        </b-row>
      </div>

      <div class="info-learning-outcome mt-4 mb-1">
        <div class="my-1 font-weight-bold">Competency</div>
        <div
          v-if="learningUnit.competency_detail"
          v-safe-html="learningUnit.competency_detail"
        ></div>
      </div>

      <!-- <div
        v-if="learningUnit && learningUnit.ultimate_learning_outcome"
        
      >
        <div class="my-1 font-weight-bold">Competency</div>

        <div class="my-1 mb-2 text-pre-line" ref="learning-outcome-description">
          {{ learningOutcome.description || "-" }}
        </div>

        <b-row class="my-1">
          <b-col cols="2" class="ml-3 pr-0 d-flex justify-content-between"
            ><div class="font-weight-bold">Pass</div>
            <div class="mr-3">—</div></b-col
          >
          <b-col
            class="text-dark pl-0 text-pre-line"
            ref="learning-outcome-pass"
            >{{ learningOutcome.pass_criterion || "-" }}</b-col
          >
        </b-row>

        <b-row>
          <b-col cols="2" class="ml-3 pr-0 d-flex justify-content-between"
            ><div class="font-weight-bold">Not yet</div>
            <div class="mr-3">—</div></b-col
          >
          <b-col
            class="text-dark pl-0 text-pre-line"
            ref="learning-outcome-not-yet"
            >{{ learningOutcome.not_yet_criterion || "-" }}</b-col
          >
        </b-row>
        <content-ultimate-learning-outcome
          :learning-outcome="learningUnit.ultimate_learning_outcome"
          :learning-unit="learningUnit"
          :edittable="false"
          :deleteable="false"
        ></content-ultimate-learning-outcome>
      </div> -->

      <div v-if="learningUnit" class="learning-unit-description mt-4 mb-1">
        <div class="font-weight-bold mb-1">Description</div>
        <div v-safe-html="learningUnit.description" class="text__lu-description"></div>
      </div>
    </template>
  </card-info>
</template>

<script>
import { learningUnitInfoMixin } from '@/mixins/learningUnitInfoMixin';
import { datetimeMixin } from '@/mixins/datetimeMixin';
// import User from "@/models/User";
import BaseUserProfile from '@/components/base-components/BaseUserProfile';
import CardInfo from './CardInfo';
import LearningUnitMember from '@/models/LearningUnitMember';
import UserRole from '@/models/UserRole';
// import ContentUltimateLearningOutcome from "@/components/LearningOutcome/ContentUltimateLearningOutcome";

export default {
  components: {
    CardInfo,
    BaseUserProfile
    // ContentUltimateLearningOutcome,
  },
  mixins: [learningUnitInfoMixin, datetimeMixin],

  computed: {
    user() {
      let user = null;

      const learningUnitMember = LearningUnitMember.query()
        .where('learning_unit_id', this.learningUnitId)
        .where('user_role', UserRole.learningUnitOwner().id)
        .first();

      if (learningUnitMember) {
        user = learningUnitMember.user;
      }

      return user;
    },

    userFullName() {
      return `${this.user.firstname} ${this.user.lastname}`;
    }
  }
};
</script>

<style></style>
